export class LqdDrawSHapeHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.initDrawShape();

  }

  getDefaultSettings() {
    return {
      selectors: {
        drawShapeElement: '[data-lqd-draw-shape]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $drawShapeElement: this.$element.find(selectors.drawShapeElement),
    }
  }

  initDrawShape() {

    this.elements.$drawShapeElement.liquidDrawShape();

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdDrawSHapeHandler, { $element } );
};